import { Avatar } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useI18n } from '@/contexts/I18nContext';

interface ExchangeLogoProps {
  src?: string | null;
  name?: string | null;
  id?: string | null;
  size?: number;
}

const LOCAL_EXCHANGE_LOGOS: Record<string, string> = {
  binance: '/exchange-logos/binance.svg',
  gate: '/exchange-logos/gate.svg',
  mexc: '/exchange-logos/mexc.svg',
  htx: '/exchange-logos/htx.png',
  bingx: '/exchange-logos/bingx.svg',
  whitebit: '/exchange-logos/whitebit.png',
  bitget: '/exchange-logos/bitget.svg',
  bybit: '/exchange-logos/bybit.svg',
  okx: '/exchange-logos/okx.svg',
  kucoin: '/exchange-logos/kucoin.svg',
  upbit: '/exchange-logos/upbit.svg',
  wazirx: '/exchange-logos/wazirx.svg',
  indodax: '/exchange-logos/indodax.svg',
  huobi: '/exchange-logos/huobi.png',
};

export function resolveExchangeLogoSrc(src?: string | null, id?: string | null) {
  const exchangeId = id?.toLowerCase();
  if (exchangeId && LOCAL_EXCHANGE_LOGOS[exchangeId]) {
    return LOCAL_EXCHANGE_LOGOS[exchangeId];
  }

  return src || undefined;
}

export default function ExchangeLogo({ src, name, id, size = 28 }: ExchangeLogoProps) {
  const { t } = useI18n();
  const label = name || id || t('common.exchangeFallback');
  const fallback = (name || id || '?').slice(0, 2).toUpperCase();
  const resolvedSrc = resolveExchangeLogoSrc(src, id);

  return (
    <Avatar
      src={resolvedSrc}
      alt={t('common.logoAlt', { name: label })}
      imgProps={{ referrerPolicy: 'no-referrer' }}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        border: '1px solid rgba(226, 255, 238, 0.16)',
        bgcolor: resolvedSrc ? 'rgba(244, 255, 249, 0.94)' : alpha('#F4FFF9', 0.08),
        color: resolvedSrc ? '#06120D' : 'text.secondary',
        fontSize: size <= 24 ? '0.58rem' : '0.68rem',
        fontWeight: 800,
        '& img': {
          objectFit: 'contain',
          padding: size <= 24 ? '4px' : '5px',
        },
      }}
    >
      {fallback}
    </Avatar>
  );
}
